<template lang="pug">
  section.pa-2.d-flex.justify-end.flex-grow-1.align-center
    v-btn.rounded-xl(depressed small @click="openDialog()")
      v-icon(small left) mdi-pin
      span new

    v-btn.black.rounded-xl.ma-1.d-flex.align-center(
      small
      depressed
      :ripple="false"
      v-for="(item, i) in linkItems" :key="i"
      @click="$router.push(item.fullpath)"
    )
      v-icon.mr-1(small @click.stop.prevent="removeItem(i)") mdi-close
      span {{item.name}}

    v-dialog(width="600" v-model="dialog")
      v-card.pa-4
        v-card-text
          v-text-field(dense v-model="inputName")
          v-text-field(dense v-model="inputPath")
        v-card-actions
          v-btn(block small @click="addNew") OK
</template>

<script>
  export default {
    components: { },
    data() {
      return {
        linkItems: [],
        dialog: false,
        inputName: "",
        inputPath: "",
      }
    },

    mounted() {
      this.getLocalStorageItems()
    },

    methods: {
      openDialog() {
        this.inputName = this.$route.name
        this.inputPath = this.$route.fullPath
        this.dialog = true
      },

      getLocalStorageItems() {
        let items = JSON.parse(window.localStorage.getItem('link-items'));
        if(items){
          this.linkItems = items
        }
        console.log("items", items)
      },

      removeItem(index) {
        this.linkItems.splice(index, 1)
        this.saveList()
      },

      addNew() {
        console.log("this", this.$route)
        const item = {
          type: "link-item",
          name: this.inputName,
          routename: this.$route.name,
          fullpath: this.$route.fullPath,
          path: this.$route.path,
        }
        this.linkItems.push(item)

        this.saveList()
        this.dialog = false
      },

      saveList() {
        window.localStorage.setItem('link-items', JSON.stringify(this.linkItems));
        this.getLocalStorageItems()
      }
    }
  }
  </script>